/**
 * Template for the license allocation CSV import (#20)
 *
 * Generated in the browser rather than served as a static file: the Static Web App's SPA fallback
 * rewrites every path without a listed extension to index.html, and a .csv is not listed.
 */

/** File name the browser suggests for the template */
export const ALLOCATION_IMPORT_TEMPLATE_FILENAME = 'license-allocations-template.csv';

/**
 * Header plus two example rows. `allocatedTo` also accepts the header `email`; `allocatedToType`
 * defaults to User and `quantity` to 1 when left blank.
 */
export const ALLOCATION_IMPORT_TEMPLATE =
  'allocatedTo,allocatedToType,quantity,notes\r\n' +
  'jane.doe@ata.net,User,1,\r\n' +
  'Finance,Department,5,Shared seats\r\n';

/**
 * Offer the template as a download
 */
export function downloadAllocationImportTemplate(): void {
  const blob = new Blob([ALLOCATION_IMPORT_TEMPLATE], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = ALLOCATION_IMPORT_TEMPLATE_FILENAME;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
